// 署名情報欄
import React, { useState } from 'react';
import Shelf from '../molecules/ShelfInShelf';
import Text from '../molecules/Text';
import { KeyValue } from '../types/KeyValue';
import Heading from '../molecules/Heading';
interface Props {
  sign_info: KeyValue[];
  heading_disabled?: boolean;
}

const SignInfo: React.FC<Props> = ({ sign_info, heading_disabled }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {!heading_disabled && <Heading label="同意・署名" size="m" />}
      <Shelf
        handleClick={() => {
          setOpen(prev => !prev);
        }}
        is_open={open}
        id="sign-info"
        label="署名情報"
      >
        {sign_info.map((sign, index) => {
          return (
            <Text
              key={index}
              id={`sign-info-${index}`}
              disabled={false}
              label={sign.key}
              handleChange={() => {}}
              value={sign.value}
              placeholder={''}
              looks_inactive={true}
            />
          );
        })}
      </Shelf>
    </>
  );
};

export default SignInfo;
